import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const employeeList = async ({
  companyCode,
  locationCode,
  departmentCode = 0,
  employeeType = "",
  groupCode = 0,
  nsEligible = false,
  isAllCompanies = false,
  userId = 0,
  selectedCompanyCode = "",
}) => {
  if (companyCode) {
    let queryString = `?isAll=true&CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;

    // if(nsEligible){
    // queryString += `&nsEligible=${nsEligible}`;
    // }

    if (departmentCode !== 0) {
      queryString += `&DepartmentCode=${departmentCode}`;
    }

    if (employeeType !== "") {
      queryString += `&EmployeeType=${employeeType}`;
    }

    if (groupCode !== 0) {
      queryString += `&GroupCode=${groupCode}`;
    }

    if (isAllCompanies) {
      queryString += `&UserId=${userId}`;
    }

    const { data } = await http_payroll.get(
      `${isAllCompanies ? Api_EndPoints.AllCompanies_EmployeeReports : Api_EndPoints.GetEmployeeList}${queryString}`,
    );
    return data;
  }
  return [];
};

// export const useGetEmployeeQuery = (input) => {
//   return useQuery({
//     queryKey: [Api_EndPoints.GetEmployeeList],
//     queryFn: () => employeeList(input),
//     refetchOnWindowFocus: false,
//   });
// };

export const useGetEmployeeQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);

  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_EmployeeReports
        : Api_EndPoints.GetEmployeeList,
      input,
    ], // ✅ include input for caching
    queryFn: () => employeeList(input),
    // staleTime: 1000 * 60 * 5, // ✅ cache data for 5 minutes
    cacheTime: 1000 * 60 * 10, // ✅ keep unused data for 10 minutes
    refetchOnWindowFocus: false, // ✅ already good
    // keepPreviousData: true, // ✅ smooth transitions for changing input
    retry: 1, // ✅ avoid excessive retries
  });
};
